import { Coords } from "../../Common/types/Coords";

export function toLatLng(coords: Coords) {
  return new google.maps.LatLng(coords.latitude, coords.longitude);
}
